var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hy-switch',{staticClass:"ss",attrs:{"defaultPrevent":"true"},model:{value:(_vm.sthGiveChild),callback:function ($$v) {_vm.sthGiveChild=$$v},expression:"sthGiveChild"}}),_c('h1',[_vm._v(_vm._s(_vm.sthGiveChild))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }